// extracted by mini-css-extract-plugin
export default {"aging":"vnQEYjU1s3AhdycPLwxp"};